// eslint-disable-next-line @dropbox/sign/isolate-folder
import { trackHeapCustomEvent } from 'js/sign-components/common/heap';

// When this gets moved out to DPC, I'll need to copy that function into this
// file and replace its implementation.
export { trackHeapCustomEvent };
